import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getLanguageOptions,
  getRegionOptions,
} from "../../../redux/actions/executionBriefListActions";
import {
  selectLanguageResults,
  selectRegionResults,
  selectStoreTypeResults,
} from "../../../redux/selectors/commonSelectors";
import { getStoreTypeOptions } from "../../../redux/actions/workOrderActions";
import { getExecutionBriefTemplateName } from "../../../types/templates/execution-brief/execution-brief-template.function";
import { EXECUTION_TEMPLATE } from "../../../types/templates/execution-brief/execution-brief-template.enum";

import { EXECUTION_BRIEF_HOOK } from "./execution-brief-template.interface";

export const useExecutionBriefTemplateOptions = (
  hooks: EXECUTION_BRIEF_HOOK[],
  template?: EXECUTION_TEMPLATE
) => {
  const dispatch = useDispatch();

  const use = (hook: EXECUTION_BRIEF_HOOK) => hooks.includes(hook);

  useEffect(() => {
    if (use(EXECUTION_BRIEF_HOOK.LANGUAGES)) {
      dispatch(getLanguageOptions());
    }
    if (use(EXECUTION_BRIEF_HOOK.REGIONS)) {
      dispatch(getRegionOptions());
    }
    if (use(EXECUTION_BRIEF_HOOK.STORE_TYPES)) {
      dispatch(getStoreTypeOptions(getExecutionBriefTemplateName(template)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, template]);

  const languagesList = useSelector(selectLanguageResults);
  const languagesOptions = languagesList.map((language) => ({
    value: language.id,
    label: language.languageLong,
  }));

  const regionsList = useSelector(selectRegionResults);
  const regionsOptions = regionsList.map((region) => ({
    value: region.id,
    label: region.name,
  }));

  const storeTypeList = useSelector(selectStoreTypeResults);
  const storeTypeOptions = storeTypeList.map((storeType) => ({
    value: storeType.id,
    label: storeType.name,
  }));

  return { languagesOptions, regionsOptions, storeTypeOptions };
};
